/**
 * Initialize "Tabs" facets.
 */
document.querySelectorAll('.js-facet-tab-tablist').forEach((tab) => {
    new TabsManual(tab);
});
